import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-core-offer-translation-failed-dialog',
    templateUrl: './offer-translation-failed-dialog.component.html',
    styleUrls: ['./offer-translation-failed-dialog.component.scss'],
    standalone: false
})
export class OfferTranslationFailedDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<OfferTranslationFailedDialogComponent>
    ) {}

    ngOnInit(): void {
    }
}
